(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    'use strict';
    
    var button = document.getElementById('videoSoundToggle');
    var video = null;
    var isMuted = true;
    var hasInteracted = false;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Find video element
    function findVideo() {
      var selectors = [
        '.background-media video',
        'video',
        'section video',
        '.section video'
      ];
      
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.tagName === 'VIDEO') {
          return el;
        }
      }
      return null;
    }
    
    // Initialize video for iOS compatibility
    function initializeVideo(videoElement) {
      if (!videoElement) return;
      
      console.log('Initializing video...');
      console.log('Video has audio tracks:', videoElement.audioTracks ? videoElement.audioTracks.length : 'unknown');
      console.log('Video muted:', videoElement.muted);
      console.log('Video volume:', videoElement.volume);
      
      // Set critical iOS attributes
      videoElement.setAttribute('playsinline', '');
      videoElement.setAttribute('webkit-playsinline', '');
      videoElement.setAttribute('x-webkit-airplay', 'allow');
      videoElement.muted = true;
      videoElement.autoplay = true;
      videoElement.loop = true;
      videoElement.preload = 'auto';
      
      // Force load and play
      videoElement.load();
      
      // Attempt to play
      var playPromise = videoElement.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('Video autoplay started successfully');
        }).catch(function(error) {
          console.log('Autoplay prevented:', error);
        });
      }
    }
    
    // AGGRESSIVE unmute function for mobile
    function unmuteVideo() {
      if (!video) {
        console.log('No video element found!');
        return;
      }
      
      console.log('=== UNMUTE ATTEMPT ===');
      console.log('Video current state:', {
        muted: video.muted,
        volume: video.volume,
        paused: video.paused,
        readyState: video.readyState,
        networkState: video.networkState,
        currentTime: video.currentTime,
        duration: video.duration
      });
      
      // Step 1: Make sure video is loaded
      if (video.readyState < 2) {
        console.log('Video not ready, forcing load...');
        video.load();
      }
      
      // Step 2: FORCE play first (critical for mobile)
      console.log('Forcing video play...');
      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('✓ Video playing');
          
          // Step 3: Wait a tiny bit for video to stabilize
          setTimeout(function() {
            // Step 4: UNMUTE
            console.log('Unmuting video...');
            video.muted = false;
            
            // Step 5: Set volume explicitly
            video.volume = 1.0;
            
            console.log('After unmute:', {
              muted: video.muted,
              volume: video.volume,
              paused: video.paused
            });
            
            // Step 6: Update UI
            isMuted = false;
            button.classList.add('unmuted');
            button.classList.remove('first-interaction-ready');
            
            // Step 7: Verify sound is actually on
            setTimeout(function() {
              if (video.muted) {
                console.log('⚠ Video re-muted itself, forcing again...');
                video.muted = false;
                video.volume = 1.0;
              }
              
              // Final check
              console.log('Final state:', {
                muted: video.muted,
                volume: video.volume,
                paused: video.paused
              });
              
              if (!video.muted && video.volume > 0 && !video.paused) {
                console.log('✓✓✓ SUCCESS! Video should have sound now!');
              } else {
                console.log('❌ FAILED - Video state is wrong');
              }
            }, 200);
            
          }, 100);
          
        }).catch(function(err) {
          console.log('❌ Play error:', err);
          
          // Try anyway
          video.muted = false;
          video.volume = 1.0;
          isMuted = false;
          button.classList.add('unmuted');
          button.classList.remove('first-interaction-ready');
        });
      } else {
        // No promise support, direct approach
        console.log('No promise support, using direct approach...');
        video.muted = false;
        video.volume = 1.0;
        isMuted = false;
        button.classList.add('unmuted');
        button.classList.remove('first-interaction-ready');
      }
    }
    
    // Mute video
    function muteVideo() {
      if (!video) return;
      
      console.log('Muting video...');
      video.muted = true;
      video.volume = 0;
      isMuted = true;
      button.classList.remove('unmuted');
      
      console.log('Video muted, state:', {
        muted: video.muted,
        volume: video.volume
      });
    }
    
    // Handle first interaction - unmute automatically
    function handleFirstInteraction(e) {
      console.log('First interaction detected:', e.type, 'Target:', e.target);
      
      // Don't trigger on the sound button itself
      var targetButton = e.target.closest('#videoSoundToggle');
      if (targetButton) {
        console.log('Interaction was on sound button, skipping auto-unmute');
        return;
      }
      
      if (!hasInteracted && video) {
        console.log('Processing first interaction for auto-unmute...');
        hasInteracted = true;
        
        // Remove all interaction listeners immediately
        removeInteractionListeners();
        
        // Unmute the video
        unmuteVideo();
      }
    }
    
    // Remove all interaction listeners
    function removeInteractionListeners() {
      document.removeEventListener('click', handleFirstInteraction, true);
      document.removeEventListener('touchend', handleFirstInteraction, true);
      document.removeEventListener('touchstart', handleFirstInteraction, true);
      document.body.removeEventListener('click', handleFirstInteraction, true);
      document.body.removeEventListener('touchend', handleFirstInteraction, true);
      document.body.removeEventListener('touchstart', handleFirstInteraction, true);
      console.log('Removed all interaction listeners');
    }
    
    // Add interaction listeners
    function addInteractionListeners() {
      // Use capture phase (true) to catch events before they bubble
      document.addEventListener('click', handleFirstInteraction, true);
      document.addEventListener('touchend', handleFirstInteraction, true);
      
      // Also add to body as backup
      document.body.addEventListener('click', handleFirstInteraction, true);
      document.body.addEventListener('touchend', handleFirstInteraction, true);
      
      // For mobile, also listen to touchstart
      if (isMobile) {
        document.addEventListener('touchstart', handleFirstInteraction, true);
        document.body.addEventListener('touchstart', handleFirstInteraction, true);
      }
      
      console.log('Added interaction listeners for auto-unmute');
    }
    
    // Toggle sound function (for button clicks)
    function toggleSound(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      
      console.log('=== BUTTON CLICKED ===');
      
      if (!video) {
        video = findVideo();
        if (video) {
          initializeVideo(video);
        }
      }
      
      if (!video) {
        console.log('❌ Video not found');
        return;
      }
      
      // Mark as interacted so auto-unmute doesn't trigger
      if (!hasInteracted) {
        hasInteracted = true;
        removeInteractionListeners();
      }
      
      button.classList.remove('first-interaction-ready');
      
      if (isMuted) {
        console.log('Currently muted, attempting unmute...');
        unmuteVideo();
      } else {
        console.log('Currently unmuted, muting...');
        muteVideo();
      }
    }
    
    // Initialize
    function init() {
      console.log('=== VIDEO SOUND CONTROLS INIT ===');
      console.log('Device:', {
        iOS: isIOS,
        Mobile: isMobile,
        UserAgent: navigator.userAgent
      });
      
      if (!button) {
        console.log('❌ Sound button not found');
        return;
      }
      
      video = findVideo();
      
      if (video) {
        console.log('✓ Video found');
        initializeVideo(video);
        
        // Add visual indicator that button is ready for first interaction
        setTimeout(function() {
          if (!hasInteracted) {
            button.classList.add('first-interaction-ready');
            console.log('Added pulse animation to button');
          }
        }, 2000);
      } else {
        console.log('⚠ Video not found yet, will retry...');
      }
      
      // Button click/touch handlers
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSound(e);
      });
      
      button.addEventListener('touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleSound(e);
      });
      
      // Prevent iOS from intercepting the button
      button.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      });
      
      // Add interaction listeners for auto-unmute
      addInteractionListeners();
      
      // Retry finding and initializing video with multiple attempts
      var retryCount = 0;
      var maxRetries = 4;
      
      function retryVideoInit() {
        if (!video && retryCount < maxRetries) {
          retryCount++;
          console.log('Retry attempt', retryCount, 'to find video...');
          video = findVideo();
          if (video) {
            console.log('✓ Video found on retry', retryCount);
            initializeVideo(video);
            if (!hasInteracted) {
              button.classList.add('first-interaction-ready');
            }
          }
        }
      }
      
      setTimeout(retryVideoInit, 500);
      setTimeout(retryVideoInit, 1500);
      setTimeout(retryVideoInit, 3000);
      setTimeout(retryVideoInit, 5000);
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Also try on window load for extra safety
    window.addEventListener('load', function() {
      if (!video) {
        console.log('Window loaded, trying to find video again...');
        video = findVideo();
        if (video) {
          initializeVideo(video);
          if (!hasInteracted) {
            button.classList.add('first-interaction-ready');
          }
        }
      }
    });
    
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero-countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    
    var button = document.getElementById('videoSoundToggle');
    var video = null;
    var isMuted = true;
    var hasInteracted = false;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Find video element
    function findVideo() {
      var selectors = [
        '.background-media video',
        'video',
        'section video',
        '.section video'
      ];
      
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.tagName === 'VIDEO') {
          return el;
        }
      }
      return null;
    }
    
    // Initialize video for iOS compatibility
    function initializeVideo(videoElement) {
      if (!videoElement) return;
      
      console.log('Initializing video...');
      console.log('Video has audio tracks:', videoElement.audioTracks ? videoElement.audioTracks.length : 'unknown');
      console.log('Video muted:', videoElement.muted);
      console.log('Video volume:', videoElement.volume);
      
      // Set critical iOS attributes
      videoElement.setAttribute('playsinline', '');
      videoElement.setAttribute('webkit-playsinline', '');
      videoElement.setAttribute('x-webkit-airplay', 'allow');
      videoElement.muted = true;
      videoElement.autoplay = true;
      videoElement.loop = true;
      videoElement.preload = 'auto';
      
      // Force load and play
      videoElement.load();
      
      // Attempt to play
      var playPromise = videoElement.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('Video autoplay started successfully');
        }).catch(function(error) {
          console.log('Autoplay prevented:', error);
        });
      }
    }
    
    // AGGRESSIVE unmute function for mobile
    function unmuteVideo() {
      if (!video) {
        console.log('No video element found!');
        return;
      }
      
      console.log('=== UNMUTE ATTEMPT ===');
      console.log('Video current state:', {
        muted: video.muted,
        volume: video.volume,
        paused: video.paused,
        readyState: video.readyState,
        networkState: video.networkState,
        currentTime: video.currentTime,
        duration: video.duration
      });
      
      // Step 1: Make sure video is loaded
      if (video.readyState < 2) {
        console.log('Video not ready, forcing load...');
        video.load();
      }
      
      // Step 2: FORCE play first (critical for mobile)
      console.log('Forcing video play...');
      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('✓ Video playing');
          
          // Step 3: Wait a tiny bit for video to stabilize
          setTimeout(function() {
            // Step 4: UNMUTE
            console.log('Unmuting video...');
            video.muted = false;
            
            // Step 5: Set volume explicitly
            video.volume = 1.0;
            
            console.log('After unmute:', {
              muted: video.muted,
              volume: video.volume,
              paused: video.paused
            });
            
            // Step 6: Update UI
            isMuted = false;
            button.classList.add('unmuted');
            button.classList.remove('first-interaction-ready');
            
            // Step 7: Verify sound is actually on
            setTimeout(function() {
              if (video.muted) {
                console.log('⚠ Video re-muted itself, forcing again...');
                video.muted = false;
                video.volume = 1.0;
              }
              
              // Final check
              console.log('Final state:', {
                muted: video.muted,
                volume: video.volume,
                paused: video.paused
              });
              
              if (!video.muted && video.volume > 0 && !video.paused) {
                console.log('✓✓✓ SUCCESS! Video should have sound now!');
              } else {
                console.log('❌ FAILED - Video state is wrong');
              }
            }, 200);
            
          }, 100);
          
        }).catch(function(err) {
          console.log('❌ Play error:', err);
          
          // Try anyway
          video.muted = false;
          video.volume = 1.0;
          isMuted = false;
          button.classList.add('unmuted');
          button.classList.remove('first-interaction-ready');
        });
      } else {
        // No promise support, direct approach
        console.log('No promise support, using direct approach...');
        video.muted = false;
        video.volume = 1.0;
        isMuted = false;
        button.classList.add('unmuted');
        button.classList.remove('first-interaction-ready');
      }
    }
    
    // Mute video
    function muteVideo() {
      if (!video) return;
      
      console.log('Muting video...');
      video.muted = true;
      video.volume = 0;
      isMuted = true;
      button.classList.remove('unmuted');
      
      console.log('Video muted, state:', {
        muted: video.muted,
        volume: video.volume
      });
    }
    
    // Handle first interaction - unmute automatically
    function handleFirstInteraction(e) {
      console.log('First interaction detected:', e.type, 'Target:', e.target);
      
      // Don't trigger on the sound button itself
      var targetButton = e.target.closest('#videoSoundToggle');
      if (targetButton) {
        console.log('Interaction was on sound button, skipping auto-unmute');
        return;
      }
      
      if (!hasInteracted && video) {
        console.log('Processing first interaction for auto-unmute...');
        hasInteracted = true;
        
        // Remove all interaction listeners immediately
        removeInteractionListeners();
        
        // Unmute the video
        unmuteVideo();
      }
    }
    
    // Remove all interaction listeners
    function removeInteractionListeners() {
      document.removeEventListener('click', handleFirstInteraction, true);
      document.removeEventListener('touchend', handleFirstInteraction, true);
      document.removeEventListener('touchstart', handleFirstInteraction, true);
      document.body.removeEventListener('click', handleFirstInteraction, true);
      document.body.removeEventListener('touchend', handleFirstInteraction, true);
      document.body.removeEventListener('touchstart', handleFirstInteraction, true);
      console.log('Removed all interaction listeners');
    }
    
    // Add interaction listeners
    function addInteractionListeners() {
      // Use capture phase (true) to catch events before they bubble
      document.addEventListener('click', handleFirstInteraction, true);
      document.addEventListener('touchend', handleFirstInteraction, true);
      
      // Also add to body as backup
      document.body.addEventListener('click', handleFirstInteraction, true);
      document.body.addEventListener('touchend', handleFirstInteraction, true);
      
      // For mobile, also listen to touchstart
      if (isMobile) {
        document.addEventListener('touchstart', handleFirstInteraction, true);
        document.body.addEventListener('touchstart', handleFirstInteraction, true);
      }
      
      console.log('Added interaction listeners for auto-unmute');
    }
    
    // Toggle sound function (for button clicks)
    function toggleSound(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      
      console.log('=== BUTTON CLICKED ===');
      
      if (!video) {
        video = findVideo();
        if (video) {
          initializeVideo(video);
        }
      }
      
      if (!video) {
        console.log('❌ Video not found');
        return;
      }
      
      // Mark as interacted so auto-unmute doesn't trigger
      if (!hasInteracted) {
        hasInteracted = true;
        removeInteractionListeners();
      }
      
      button.classList.remove('first-interaction-ready');
      
      if (isMuted) {
        console.log('Currently muted, attempting unmute...');
        unmuteVideo();
      } else {
        console.log('Currently unmuted, muting...');
        muteVideo();
      }
    }
    
    // Initialize
    function init() {
      console.log('=== VIDEO SOUND CONTROLS INIT ===');
      console.log('Device:', {
        iOS: isIOS,
        Mobile: isMobile,
        UserAgent: navigator.userAgent
      });
      
      if (!button) {
        console.log('❌ Sound button not found');
        return;
      }
      
      video = findVideo();
      
      if (video) {
        console.log('✓ Video found');
        initializeVideo(video);
        
        // Add visual indicator that button is ready for first interaction
        setTimeout(function() {
          if (!hasInteracted) {
            button.classList.add('first-interaction-ready');
            console.log('Added pulse animation to button');
          }
        }, 2000);
      } else {
        console.log('⚠ Video not found yet, will retry...');
      }
      
      // Button click/touch handlers
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSound(e);
      });
      
      button.addEventListener('touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleSound(e);
      });
      
      // Prevent iOS from intercepting the button
      button.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      });
      
      // Add interaction listeners for auto-unmute
      addInteractionListeners();
      
      // Retry finding and initializing video with multiple attempts
      var retryCount = 0;
      var maxRetries = 4;
      
      function retryVideoInit() {
        if (!video && retryCount < maxRetries) {
          retryCount++;
          console.log('Retry attempt', retryCount, 'to find video...');
          video = findVideo();
          if (video) {
            console.log('✓ Video found on retry', retryCount);
            initializeVideo(video);
            if (!hasInteracted) {
              button.classList.add('first-interaction-ready');
            }
          }
        }
      }
      
      setTimeout(retryVideoInit, 500);
      setTimeout(retryVideoInit, 1500);
      setTimeout(retryVideoInit, 3000);
      setTimeout(retryVideoInit, 5000);
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Also try on window load for extra safety
    window.addEventListener('load', function() {
      if (!video) {
        console.log('Window loaded, trying to find video again...');
        video = findVideo();
        if (video) {
          initializeVideo(video);
          if (!hasInteracted) {
            button.classList.add('first-interaction-ready');
          }
        }
      }
    });
    
  })();

  } catch(e) { console.error(e); }
})();
})();
